import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './list';

export const SentryModule = () => {
  return (
    <Switch>
      <Route path="/sentries" component={List} />
    </Switch>
  );
};
